import { Component, ViewChild } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { PackageService } from 'src/app/private/services/package.service';
import { MessageService, ConfirmationService } from 'primeng/api';

import { AddonService } from 'src/app/private/services/addon.service';
import { PackageFormComponent } from "../../components/packages/package-form/package-form.component";
import { AddonListComponent } from "../../components/packages/addon-list/addon-list.component";
import { PackageListComponent } from "../../components/packages/package-list/package-list.component";
import { AddonFormComponent } from "../../components/packages/addon-form/addon-form.component";
import { FeatureService } from 'src/app/private/services/feature.service';
import { forkJoin } from 'rxjs';
import { AssignPackageComponent } from "../../components/packages/assign-package/assign-package.component";
import { ClientPackageComponent } from "../../components/client-package/client-package.component";
import { ClientAddonsComponent } from "../../components/client-package/client-addons/client-addons.component";
import { AssignAddonComponent } from "../../components/packages/assign-addon/assign-addon.component";


@Component({
  selector: 'app-packages',
  imports: [
    ToolBarComponent,
    SharedModule,
    PackageFormComponent,
    AddonListComponent,
    PackageListComponent,
    AddonFormComponent,
    AssignPackageComponent,
    ClientPackageComponent,
    ClientAddonsComponent,
    AssignAddonComponent
],
  providers: [MessageService, ConfirmationService],
  templateUrl: './packages.component.html',
  styleUrl: './packages.component.scss'
})
export class PackagesComponent {
  activeTab = 0; // 0 = Packages, 1 = Add-ons, 2 = Assign Package, 3 = Assign Add-on


  // Package modals
  showPackageFormModal = false;
  selectedPackage: any = null;

  // Add-on modals
  showAddonFormModal = false;
  selectedAddon: any = null;
  selectedClientPackage:any = null
  selectedClientAddon:any = null
  // Assignment modals
  showAssignPackageModal = false;
  showAssignAddonModal = false;
  isDeleting = false;
  showDeletePackage = false;
  showDeleteAddon = false;

  featuresList: any  = {
    fixed:[],
    limit:[]
  };

  @ViewChild(PackageListComponent) packageListRef!: PackageListComponent;
  @ViewChild(AddonListComponent) addonListRef!: AddonListComponent;

  constructor(
    private packageService: PackageService,
    private addonService: AddonService,
    private featureApi: FeatureService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
    // Component initialization
    this.getAllFeatures();
  }


  getAllFeatures() {
  const active = { where: { status: "Active", category: "limit" } };
  const fixed = { where: { status: "Active", category: "fixed" } };

  forkJoin({
    limit: this.featureApi.getAllFeatures(active),
    fixed: this.featureApi.getAllFeatures(fixed)
  }).subscribe(res => {
    this.featuresList.fixed = res.fixed
    this.featuresList.limit = res.limit
    });
}
  // getAllFeatures() {
  //   const body = {
  //     "where": {
  //       "status": "Active"
  //     }
  //   }


  //   this.featureApi.getAllFeatures(body).subscribe({
  //     next: (res) => {
  //       console.log('Active features:', res);
  //       this.featuresList = res || [];
  //       console.log('Features List set in component:', this.featuresList);
  //     },
  //     error: (err) => {
  //       console.error('Error fetching features:', err);
  //     }
  //   });

  // }

  // Package operations
  openCreatePackage() {
    this.selectedPackage = null;
    this.showPackageFormModal = true;
  }

  openEditPackage(pkg: any) {
    this.selectedPackage = pkg;
    this.showPackageFormModal = true;
  }

  deletePackage(pkg: any) {
    this.selectedPackage = pkg;
    this.showDeletePackage = true;
  }


  deletePackageConfirm() {
    this.isDeleting = true;
    const payload = { package_id: this.selectedPackage.package_id };
    this.packageService.deletePackage(payload).subscribe({
      next: () => {
        this.isDeleting = false;
        this.showDeletePackage = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: `"${this.selectedPackage.package_name}" has been removed successfully.`,
        });
        this.reloadPackages();
      },
      error: (error) => {
        this.isDeleting = false;
        console.error('Delete error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Delete Failed',
          detail: 'Something went wrong. Please try again.',
        });
      }
    });

  }


  reloadPackages() {
    if (this.packageListRef) {
      this.packageListRef.loadPackages();
    }
  }

  closePackageForm() {
    this.showPackageFormModal = false;
    this.selectedPackage = null;
  }

  // Add-on operations
  openCreateAddon() {
    this.selectedAddon = null;
    this.showAddonFormModal = true;
  }

  openEditAddon(addon: any) {
    this.selectedAddon = addon;
    this.showAddonFormModal = true;
  }

  deleteAddon(addon: any) {
    this.selectedAddon = addon;
    this.showDeleteAddon = true;
  }

  deleteAddonConfirm() {
    this.isDeleting = true;
    const payload = { id: this.selectedAddon.id };
    this.addonService.deleteAddon(payload).subscribe({
      next: () => {
        this.isDeleting = false;
        this.showDeleteAddon = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Deleted',
          detail: `"${this.selectedAddon.name}" has been removed successfully.`,
        });
        this.reloadAddons();
      },
      error: (error) => {
        this.isDeleting = false;
        console.error('Delete error:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Delete Failed',
          detail: 'Something went wrong. Please try again.',
        });
      }
    });
  }

  reloadAddons() {
    if (this.addonListRef) {
      this.addonListRef.loadAddons();
    }
  }

  closeAddonForm() {
    this.showAddonFormModal = false;
    this.selectedAddon = null;
  }

  // Assignment operations
  openClientPackage() {
    this.showAssignPackageModal = true;
  }
  editClientPackage(data:any) {
    this.selectedClientPackage = data
    this.showAssignPackageModal = true;
  }

  editAssignAddon(data:any) {
    this.selectedClientAddon = data
    this.showAssignAddonModal = true;
  }
  closeAssignPackage() {
    this.showAssignPackageModal = false;
  }

  openAssignAddon() {
    this.showAssignAddonModal = true;
  }

  closeAssignAddon() {
    this.showAssignAddonModal = false;
  }

  // Tab change
  onTabChange(event: any) {
    this.activeTab = event.index;
  }
}
